// src/pages/UploadProfilePhoto.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API_WRK = process.env.REACT_APP_API_WRK;

const UploadProfilePhoto = () => {
  const [photo, setPhoto] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const navigate = useNavigate();
  const workerId = localStorage.getItem("workerId");

  useEffect(() => {
    return () => {
      if (preview) URL.revokeObjectURL(preview);
    };
  }, [preview]);

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setPhoto(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleSubmit = async () => {
    if (!photo) return;
    if (!workerId) {
      alert("No worker session. Please log in again.");
      navigate("/worker-login");
      return;
    }

    const formData = new FormData();
    formData.append("photo", photo);
    formData.append("workerId", workerId);

    try {
      setUploading(true);
      const res = await axios.post(`${API_WRK}/upload-profile-photo`, formData);
      alert(res.data?.message || "✅ Profile photo uploaded!");
      navigate("/documents");
    } catch (err) {
      console.error("Upload failed:", err);
      alert(err?.response?.data?.message || "Failed to upload profile photo.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-white text-black">
      {/* Header */}
      <div className="bg-black text-white p-4 text-lg font-bold text-center">
        Profile Photo
      </div>

      {/* Instructions */}
      <div className="p-4 text-sm text-gray-800">
        Please upload a clear and professional selfie. Ensure good lighting and a neutral
        background. This photo will be used for verification and job ID.
      </div>

      {/* Preview */}
      {preview && (
        <div className="flex justify-center items-center p-4">
          <img
            src={preview}
            alt="Preview"
            className="w-36 h-36 object-cover rounded-full border-2 border-gray-300 shadow-md"
          />
        </div>
      )}

      {/* Footer Button */}
      <div className="mt-auto p-4 bg-black">
        <label className="w-full">
          <input
            type="file"
            accept="image/*"
            capture="user"
            onChange={handleFileChange}
            className="hidden"
          />
          <div className="text-white text-center font-semibold py-3 rounded-md border border-white cursor-pointer">
            Take Photo
          </div>
        </label>

        {photo && (
          <button
            onClick={handleSubmit}
            disabled={uploading}
            className={`mt-3 w-full text-white py-2 rounded-md font-semibold ${
              uploading ? "bg-blue-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
            }`}
          >
            {uploading ? "Uploading..." : "Submit Photo"}
          </button>
        )}
      </div>
    </div>
  );
};

export default UploadProfilePhoto;
